import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';


const companyContact = {
	name: 'Santtu Laivuori',
	role: 'CEO',
	email: 'santtu.laivuori@lenz.fi',
	phone: '+358 40 234 5678',
	image: 'http://www.lenz.fi/wp-content/uploads/2024/11/Artboard-3@72x.png',
};

const studentContact = {
	name: 'Anissa Mouhou',
	role: 'Rekrytoinnin asiantuntija',
	email: 'anissa.mouhou@lenz.fi',
	phone: '',
	image: 'http://www.lenz.fi/wp-content/uploads/2024/11/Artboard-8@72x.png',
};

const Contact = ({ userRole }) => {
	const contactInfo =
		userRole === 'student' ? studentContact : companyContact;

	return (
		<Container
			id="contact"
			component="section"
			sx={{ py: { xs: 4, sm: 12, md: 16 } }}
		>

      
			<Typography
				variant="h2"
				align="center"
				sx={{
					fontSize: { xs: '1.75rem', sm: '2.5rem', md: '3rem' },

					fontWeight: 500,

					mb: { xs: 3, sm: 4 },
				}}
			>
				Ota yhteyttä
			</Typography>

			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
					gap: 3,
				}}
			>
				{/* Left card */}
				<Paper
					sx={{
						p: { xs: 3, sm: 4 },

						backgroundColor: '#F8F4E3',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						textAlign: 'center',
						minHeight: { xs: 300, sm: 400 },
					}}
				>
					<Typography
						variant="h3"
						sx={{
							fontSize: { xs: '1.5rem', sm: '1.75rem' },
							fontWeight: 500,
							mb: 2,
						}}
					>

						{userRole === 'student'
							? 'Liity talentpooliin'
							: 'Varaa aika keskusteluun'}

					</Typography>
					<Typography
						sx={{
							mb: 4,
							color: 'text.secondary',
							fontSize: { xs: '1rem', sm: '1.1rem' },
						}}
					>

						{userRole === 'student'
							? 'Etsitkö joustavaa työtä opintojen ohelle?'
							: `Varaa 15 minuutin tapaaminen ${contactInfo.name}n kanssa ja kuule lisää Lenz Platformista ja sen mahdollisuuksista.`}

					</Typography>
					<Button
						variant="contained"
						size="large"
						sx={{
							borderRadius: 50,
							px: 4,
							backgroundColor: 'primary.main',
						}}

						href={
							userRole === 'student'
								? 'https://ace93.typeform.com/to/xcwxrM4n?utm_source=xxxxx&utm_medium=xxxxx&utm_campaign=xxxxx&utm_term=xxxxx&utm_content=xxxxx#user_id=xxxxx'
								: 'https://calendar.app.google/oYSUvZNVbQxbydcK9'
						}
						target="_blank"
						rel="noopener noreferrer"
					>
						{userRole === 'student'
							? 'Hae TalentPooliin'
							: 'Varaa aika'}

					</Button>
				</Paper>

				{/* Right card */}
				<Paper
					sx={{
						p: { xs: 3, sm: 4 },
						pb: 0,

						backgroundColor: '#F8F4E3',

						display: 'flex',
						flexDirection: 'column',
						minHeight: { xs: 300, sm: 400 },
					}}
				>
					<Typography
						variant="h3"
						sx={{
							fontSize: { xs: '1.5rem', sm: '2rem' },
							fontWeight: 500,
							mb: 1,
						}}
					>
						Haluatko kuulla lisää?
					</Typography>
					<Typography
						sx={{
							color: 'text.secondary',
							fontSize: '1rem',
							lineHeight: 1.5,
						}}
					>

						Voit olla yhteydessä{' '}
						{userRole === 'student'
							? 'rekrytointiin'
							: 'Lenzin perustajaan Santtu Laivuoreen'}
					</Typography>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'flex-end',
							mt: 2,
							position: 'relative',
							flex: 1,
						}}
					>
						<Stack spacing={0.5} sx={{ mb: 4 }}>
							<Typography
								variant="h6"
								sx={{
									fontWeight: 500,
									fontSize: '1.25rem',
								}}
							>

								{contactInfo.name}

							</Typography>
							<Typography
								sx={{
									color: 'text.secondary',
									fontSize: '0.875rem',
								}}
							>

								{contactInfo.role}

							</Typography>
							<Typography
								sx={{
									color: 'text.secondary',
									fontSize: '0.875rem',
								}}
							>

								{contactInfo.email}
							</Typography>
							{contactInfo.phone && (
								<Typography
									sx={{
										color: 'text.secondary',
										fontSize: '0.875rem',
									}}
								>
									{contactInfo.phone}
								</Typography>
							)}
						</Stack>
						<Box
							component="img"
							src={contactInfo.image}
							alt={contactInfo.name}

							sx={{
								width: { xs: 200, sm: 320 },
								height: { xs: 200, sm: 320 },
								objectFit: 'cover',
								display: 'block',
							}}
						/>
					</Box>
				</Paper>
			</Box>
		</Container>
	);
};

export default Contact;
